import { useSelector } from "react-redux";

import { selectFiltersPanelValue } from "app/pages/sales-intelligence/modules/leads-search-filters/store/selectors";
import type { LeadsSearchAllFiltersTypes } from "app/pages/sales-intelligence/modules/leads-search-filters/types/leadsSearchFilters.dto";

import { useFiltersUpdate } from "./useFiltersUpdate";

type FiltersValueToDTOResult = [
    Partial<LeadsSearchAllFiltersTypes>,
    (filters: Partial<LeadsSearchAllFiltersTypes>) => void,
];

/** Panel value + update handler. Initial-value seeding runs once at the page root (`useApplyInitialFilters`). */
function useFiltersValueState(): FiltersValueToDTOResult {
    // Flat, field-atomic panel value; `useFiltersManager` folds composite member fields under their group
    // key on read and spreads them back on write, so redux and the DTO adapters stay field-atomic.
    const filterPanelValue: Partial<LeadsSearchAllFiltersTypes> = useSelector(selectFiltersPanelValue);

    const handleFiltersUpdate = useFiltersUpdate();

    return [filterPanelValue, handleFiltersUpdate];
}

export default useFiltersValueState;
